
import type { ApiResult } from '@/api/core/request/types'
import { iOS } from '@/utils/ua'

import post from '../../core/methods/post'
import { AppPrivacyReq, AppPrivacyRes } from './types'

const cache = new Map<'app_privacy', ApiResult & AppPrivacyRes>()

/**
 * 用户协议获取
 * @description https://api.yinnho.cn/api.php?do=app_privacy&help
 * @param data 请求参数
 */
export async function app_privacy (data?: AppPrivacyReq) {
  if (cache.has('app_privacy')) {
    return cache.get('app_privacy')
  }

  const _data = {
    appname: iOS ? 'iOS应合' : '安卓应合',
    type: 'content',
    ...data,
  }

  const res = await post<AppPrivacyRes>('app_privacy', _data)

  if (res.data.error_code === 0) {
    cache.set('app_privacy', res.data)
  }

  return res.data
}
